var FROM_YEAR = 1990;
var MAX_PAGE = 100;

export { FROM_YEAR, MAX_PAGE };
//# sourceMappingURL=constants.esm.js.map
